export enum CollaborationTypeEnum {
  CAR_SPOTTING = 'CAR_SPOTTING',
  PHOTO_SESSION = 'PHOTO_SESSION',
  VIDEO_SESSION = 'VIDEO_SESSION',
  DETAILING = 'DETAILING',
  MECHANIC_SERVICE = 'MECHANIC_SERVICE',
  WRAP = 'WRAP',
  PAINTWORK = 'PAINTWORK',
  WHEELS_TYRES = 'WHEELS_TYRES',
  TUNING = 'TUNING',
  CUSTOM = 'CUSTOM',
  OTHER_SERVICE = 'OTHER_SERVICE'
}

export const COLLABORATION_TYPES: CollaborationTypeEnum[] = Object.values(CollaborationTypeEnum);

export const SERVICE_COLLABORATION_TYPES: CollaborationTypeEnum[] = [
  CollaborationTypeEnum.DETAILING,
  CollaborationTypeEnum.MECHANIC_SERVICE,
  CollaborationTypeEnum.WRAP,
  CollaborationTypeEnum.PAINTWORK,
  CollaborationTypeEnum.WHEELS_TYRES,
  CollaborationTypeEnum.TUNING,
  CollaborationTypeEnum.OTHER_SERVICE,
];
